import React from 'react';

import SectionLoadingView from '../SectionLoadingView';
import RoleCompetencyScreen from './competencyScreen/RoleCompetencyScreen';
import { useLevelUpContext } from './context';
import WelcomeScreen from './welcomeScreen/WelcomeScreen';

const LevelUpViews = ({ employee, isOneOnOne = false }) => {
  const {
    state: { levelUpDetails, isLoading },
  } = useLevelUpContext();

  if (isLoading) {
    return (
      <div style={{ width: '100%' }}>
        <SectionLoadingView />
      </div>
    );
  }

  if (levelUpDetails) {
    if (levelUpDetails.isShowWelcome) {
      return <WelcomeScreen employee={employee} isOneOnOne={isOneOnOne} />;
    }
    return <RoleCompetencyScreen employee={employee} />;
  }

  return null;
};

export default LevelUpViews;
